import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductPrice, { ProductPriceStyles } from "@NA/Overrides/Components/ProductPrice";
import ADIColors from "@NA/Utils/ADIColors";
import ProductComapreCheckbox, {
    ProductComapreCheckboxStyles,
} from "@NA/Widgets/ProductCompare/ProductCompareCheckbox";
import * as React from "react";
import { css } from "styled-components";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import ADIProductPartNumbers, { ADIProductPartNumbersStyles } from "../RecentlyPurchasedProduct/ADIProductPartNumbers";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import CrossIcon from "@NA/Icons/CrossIcon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { AdiProductAddToCartButtonStyles } from "../RecentlyPurchasedProduct/ADIProductAddToCartButton";
import { ADIProductPriceStyles } from "../RecentlyPurchasedProduct/ADIProductPrice";
import { FormInputWrapper } from "@insite/mobius/FormField";

export interface ProductCarouselProductStyles {
    productImageStyles?: ProductImageStyles;
    productBrandWrapper?: InjectableCss;
    productDescriptionContainer?: InjectableCss;
    productPartNumbersContainer?: InjectableCss;
    imageWrapper?: InjectableCss;
    mobLeftSideContainer?: InjectableCss;
    mobProdPartNumbers?: InjectableCss;
    mobRightSideContainer?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ADIProductPartNumbersStyles;
    productPriceWrapper?: InjectableCss;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: InjectableCss;
    addToCartContainerWithoutSignIn?: InjectableCss;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: InjectableCss;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    availabilityGridItem?: InjectableCss;
    availabilityStyles?: ProductAvailabilityStyles;
    productComapreCheckboxStyles?: ProductComapreCheckboxStyles;
    productPriceStyles?: ProductPriceStyles;
    signInDealerPrice?: InjectableCss;
    dealerPriceText?: TypographyProps;
    dealerCertificationModal?: ModalPresentationProps;
    dealerCertificationWrapper?:InjectableCss;
    dealerMsg?: InjectableCss;
    continue?: InjectableCss;
    vendorLink?: InjectableCss;
    showAuthContainer?: InjectableCss;
    showDesktopAuthContainer?: InjectableCss;
    showAuthInnerContainer?: InjectableCss;
    stylesdealerTitle?: InjectableCss;
    getCertifiedText?: InjectableCss;
    isPendingVerificationSignIn?: InjectableCss;
    errorMessageText?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    recentlyViewedContainer?: InjectableCss;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    cartCarouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    cartCarouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    dotsContainerWrapper?: InjectableCss;
    dotButton?: ButtonPresentationProps;

    wrapper?: InjectableCss;
    cartWrapper?: InjectableCss;
    newImageWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    cartMobLeftSideContainer?: InjectableCss;
    cartMobProdPartNumbers?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    cartProductDescription?: InjectableCss;
    adiProductPriceStyles?: ADIProductPriceStyles;
    addToCartBtnWrapper?: GridItemProps;
    brandGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    cartDescriptionGridItem?: GridItemProps;
    cartBrandGridItem?: GridItemProps;
    cartPartNumberGridItem?: GridItemProps;
    priceGridItem?: GridItemProps;
    cartPriceGridItem?: GridItemProps;
    deliveryMsgGridItem?: GridItemProps;
    cartAvailabilityGridItem?: GridItemProps;
    addToCartGridItem?: GridItemProps;
    cartPageAddToCartGridItem?: GridItemProps;
    addToCartStyles?: AdiProductAddToCartButtonStyles;
    cartMobRightSideContainer?: InjectableCss;
    messageLink?: InjectableCss;
    AddToCart?: ButtonPresentationProps;
    loading?: ButtonPresentationProps;
    pendingVerificationText?: InjectableCss;
    pendingVerification?: InjectableCss;
    pendingVerificationParent?: InjectableCss;
    VerificationText: TypographyPresentationProps;
}

export const productCarouselProductStyles: ProductCarouselProductStyles = {
    VerificationText: {
        css: css`
                           
                                text-transform: none !important;
                                font-size: 14px !important;
                                font-weight: bold;
                                color: ${ADIColors.blue5} !important;                              
                            }
                        `,
    },
    productBrandWrapper: {
        css: css`
            margin: 0;
            padding: 10px 20px 5px;
            line-height: 1;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 10px 15px 5px;
                        `,
                    ],
                    "max",
                );
            }}
            a {
                ${TypographyStyle} {
                    color: ${ADIColors.darkBlack3};
                    &:hover {
                        color: ${ADIColors.darkBlack3};
                    }
                }
            }
            ${TypographyStyle} {
                color: ${ADIColors.darkBlack3} !important;
                font-weight: 600;
                font-size: 12px;
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    isPendingVerificationSignIn: {
        css: css`
            flex-grow: 0;
            padding-top: 35px;
            margin: 20px;
            cursor: auto;
            > div:hover {
                background-color: transparent;
                span {
                    color: ${ADIColors.darkBlue1};
                }
            }
            span {
                color: ${ADIColors.darkBlue1};
            }
        `,
    },
    dealerCertificationModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
            css: css`
            button {
                font-size:16px;
                font-weight: 700;
                `,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 521px !important;
                border-radius: 4px;
                padding: 28px 28px 38px 28px !important;
                position: fixed;
                top: 100px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                height: auto;
                            `,
                            null,
                            null,
                            css`
                                max-height: fit-content;
                            `,
                            null,
                        ],
                        "min",
                    );
                }}
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 28px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: 1.07;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    margin-top: -45px;
                    margin-right: -20px;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    dealerMsg: {
        css: css`
            padding-bottom: 20px;
            font-size: 14px;
            line-height: 1.71;
            font-weight: normal;
        `,
    },
    continue: {
        css: css`
            min-height: 21px;
            padding: 10px 20px;
            line-height: 21px;
            border: 0px;
        `,
    },
    vendorLink: {
        css: css`
            margin-left: 2px;
        `,
    },
    showAuthContainer: {
        css: css`
            display: flex;
            height: 100%;
            align-items: end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    showDesktopAuthContainer: {
        css: css`
            display: flex;
            height: 100%;
            align-items: end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex;
                    `,
                ])}
        `,
    },
    showAuthInnerContainer: {
        css: css`
            width: 100%;
            text-align: center;
            border-top: solid 1px ${ADIColors.gray7};
            padding: 10px 10px !important;
            height: 64px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            height: 55px;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    getCertifiedText: {
        css: css`
            > span {
                text-transform: none !important;
                font-size: 14px !important;
                font-weight: bold;
                &:hover {
                    text-decoration: underline !important;
                    color: ${ADIColors.blue5} !important;
                }
            }
        `,
    },
    productComapreCheckboxStyles: {
        wrapper: {
            css: css`
                div[class^="CheckboxStyle"] {
                    flex-direction: row-reverse;
                    margin: 7px 10px 7px 0px;
                    position: relative;
                    float: right;
                }
            `,
        },
    },
    productDescriptionContainer: {
        css: css`
            padding: 0px 20px;
            flex-basis: 100%;
            max-width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 2px 15px 10px;
                        `,
                    ],
                    "max",
                );
            }}
            @media screen and (max-width: 767px) {
                > a span {
                    -webkit-line-clamp: 3 !important;
                    font-size: 16px;
                }
            }
        `,
    },
    productPartNumbersContainer: {
        css: css`
            padding: 5px 20px 5px;
            line-height: 1;
            flex-basis: 100%;
            max-width: 100%;
            @media screen and (max-width: 767px) {
                span[data-test-selector="productNumber"],
                span[data-test-selector="manufacturerItem"] {
                    text-align: center;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    availabilityGridItem: {
        css: css`
            padding: 10px 20px;
            flex-basis: 100%;
            max-width: 100%;
        `,
    },
    imageWrapper: {
        css: css`
            margin: 25px 0 0;
            img {
                max-height: 160px;
                max-width: 231px;
                height: 160px;
                width: 160px;
                margin: 0 auto;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            height: auto;
                            width: 100%;
                        `,
                    css`
                            height: auto;
                            width: 70%;
                        `,
                    null,
                    null,
                    null,
                ])}
            }
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            display: flex;
            position: relative;
            margin: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    mobLeftSideContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 40%;
                        display: inline-block;
                        > div[class^="sc"] {
                            padding: 15px 0px 10px 15px;
                            margin: 0;
                            &:last-child {
                                min-height: 310px;
                            }
                        }
                    `,
                    css`
                        width: 40%;
                        display: inline-block;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    mobProdPartNumbers: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        div[class^="GridOffset"] {
                            justify-content: center;
                        }
                        padding-top: 5px;
                        ${TypographyStyle} {
                            display: block;
                            text-align: center;
                            line-height: normal;
                            ${TypographyStyle} {
                                display: none;
                            }
                        }
                    `,
                    css`
                        div[class^="GridOffset"] {
                            justify-content: center;
                        }
                        text-align: center;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    mobRightSideContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 60%;
                        display: inline-block;
                    `,
                    css`
                        width: 60%;
                        display: inline-block;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    productDescriptionStyles: {
        productDetailLink: {
            css: css`
                //margin-bottom: 6px;
                span {
                    color: ${getColor("text.main")} !important;
                    font-weight: 600 !important;
                    min-height: 60px;
                    display: -webkit-box !important;
                    line-clamp: 2 !important;
                    -webkit-line-clamp: 2 !important;
                    -webkit-box-orient: vertical;
                    overflow: hidden !important;
                    width: 100%;
                    line-height: normal;
                    font-size: 14px;
                    &:hover {
                        color: ${getColor("text.main")} !important;
                    }
                }
            `,
        },
    },
    productPartNumbersStyles: {
        partNumber: {
            size: 10,
            weight: 600,
            css: css`
                color: ${ADIColors.gray4};
            `,
        },
    },
    productPriceWrapper: {
        css: css`
            flex-grow: 1;
            margin-bottom: 6px;
            padding: 0px 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0 15px;
                        `,
                    ],
                    "max",
                );
            }}
            [data-test-selector="recommendeProductPrice"] {
                align-items: center;
                display: flex;
            }
        `,
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                margin-top: 6px;
            `,
        },
    },
    productPriceStyles: {
        price: {
            priceText: {
                weight: "bold",
                css: css`
                    color: ${ADIColors.darkBlue4};
                    display: flex;
                    flex-wrap: wrap;
                    .symbolText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-right: 2px;
                        position: relative;
                        top: 0px;
                    }
                    .priceText {
                        font-size: 30px;
                        font-weight: 900;
                        line-height: 1.1;
                    }
                    .currencyText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-left: 2px;
                        position: relative;
                        top: -2px;
                    }
                    .unitofmeasureText {
                        font-size: 12px !important;
                        position: relative;
                        font-weight: 600;
                        color: #666;
                        display: block !important;
                    }
                `,
            },
        },
    },
    addToCartContainer: {
        css: css`
            flex-grow: 0;
            padding-top: 10px;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-left: -66%;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    addToCartContainerWithoutSignIn: {
        css: css`
            flex-grow: 0;
            max-width: 100%;
            flex-basis: 100%;
            padding: 10px 0 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-top: 60px;
                            margin: 20px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    pendingVerificationParent: {
        css: css`
            flex-grow: 0;
            max-width: 100%;
            flex-basis: 100%;
            padding: 10px 0 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-top: 60px;
                            margin: 20px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    qtyGridItem: { width: 3 },
    productQuantityOrderedStyles: {
        cssOverrides: {
            formField: css`
                margin-top: 0;
            `,
        },
    },
    addToCartButtonGridItem: {
        css: css`
            button {
                height: 64px;
                border: 0px !important;
                border-top: 1px solid ${ADIColors.gray7} !important;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            padding: 0;
                            height: 64px;
                            border-top: 0px;
                        `,
                    css`
                            padding: 0;
                            height: 64px;
                            border-top: 0px;
                        `,
                    null,
                    null,
                    null,
                ])}
            }
        `,
    },
    productAddToCartButtonStyles: {
        css: css`
            width: 100%;
        `,
    },
    productAddToListLinkStyles: {
        link: {
            typographyProps: { size: 13 },
            css: css`
                margin-bottom: 12px;
            `,
        },
    },
    signInDealerPrice: {
        css: css`
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            padding: 20px 0;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            bottom: 0;
            width: 100%;
            left: 0;
            right: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            position: absolute;
                            margin-top: 30px;
                        `,
                    ],
                    "max",
                );
            }}
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: ${ADIColors.white};
                }
            }
        `,
    },
    pendingVerification: {
        css: css`
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            padding: 20px 0;
            cursor: auto;
            transition: 0.2s ease;
            margin-top: auto;
            bottom: 0;
            width: 100%;
            left: 0;
            right: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            position: absolute;
                            margin-top: 30px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    dealerPriceText: {
        css: css`
            color: ${getColor("primary")};
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: bold;
        `,
    },

    pendingVerificationText: {
        css: css`
            color: ${ADIColors.darkBlue1};
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: 700;
        `,
    },

    errorMessageText: {
        color: "danger",
        css: css`
            margin-top: 20px;
        `,
    },
    titleText: {
        variant: "h2",
        css: css`
            text-align: start;
            margin-bottom: 10px;
        `,
    },
    recentlyViewedContainer: {
        css: css`
            display: inline-block;
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                        position: absolute;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                ])}
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            position: absolute;
            top: 8%;
            right: 50px;
            transform: rotate(180deg);
            background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/arrow-carousel-next-rd.svg)
                no-repeat;
            border: 0;
            width: 28px !important;
            height: 28px !important;
            opacity: 1;
            margin-bottom: 0;
            background-size: 28px 28px !important;
            z-index: 99;
            &:disabled {
                background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/ArrowCarouselright-2.svg)
                    no-repeat;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        right: 0%;
                        top: 31%;
                        display: none;
                    `,
                    css`
                        top: 9%;
                        right: 11%;
                    `,
                    css`
                        top: -9%;
                        right: 60px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                        position: absolute;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                ])}
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            position: absolute;
            top: 29%;
            right: 0px;
            background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/arrow-carousel-next-rd.svg)
                no-repeat;
            border: 0;
            width: 28px !important;
            height: 28px !important;
            opacity: 1;
            margin-bottom: 0;
            background-size: 28px 28px !important;
            z-index: 99;
            &:disabled {
                background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/ArrowCarouselright-2.svg)
                    no-repeat;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        right: 10%;
                        top: 15%;
                        display: none;
                    `,
                    css`
                        top: 30%;
                        right: 5%;
                    `,
                    css`
                        top: 9%;
                        right: 10px;
                    `,

                    null,
                    null,
                ])}
        `,
    },
    carouselGridItem: {
        width: 10,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            flex-basis: 20%;
            max-width: 20%;
            padding: 0 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 33.333%;
                        max-width: 33.333%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                ])}
        `,
    },
    cartCarouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            flex-basis: 20%;
            max-width: 20%;
            padding: 0 10px;
            display: inline-flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        width: 100%;
                    `,
                    css`
                        flex-basis: 33.333%;
                        max-width: 33.333%;
                        flex-basis: 100%;
                        max-width: 100%;
                        width: 100%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                ])}
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            padding: 0px;
            display: flex;
            flex-direction: column;
            border: 1px solid ${ADIColors.gray7};
            border-radius: 5px;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                        height: auto;
                    `,
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                        height: auto;
                    `,
                    css`
                        height: 100%;
                    `,
                    css`
                        height: 100%;
                    `,
                    css`
                        height: 100%;
                    `,
                ])}
        `,
    },
    cartCarouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            padding: 0px;
            display: flex;
            flex-direction: column;
            border-radius: 5px;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                    `,
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    dotsContainerWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            margin-top: 24px;
            position: absolute;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 93%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    dotButton: {
        css: css`
            min-height: 7px;
            max-width: 55px;
            height: 3px;
            width: 10%;
            padding: 0;
            margin: 0 4px;
            border: 0px;
            border-radius: 2px;
            background: ${getColor("common.border")};
            background-color: ${ADIColors.gray16};
            border: 1px solid ${ADIColors.gray16};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 0 0;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
            &:hover {
                background: ${ADIColors.white};
            }
            &:active {
                background-color: ${ADIColors.darkBlue1};
                border: 1px solid ${ADIColors.darkBlue1};
            }
            &:focus {
                outline: none;
            }
        `,
    },

    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border: 1px solid ${getColor("text.disabled")};
            border-radius: 5px;
            position: relative;
            background: ${ADIColors.white};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                    `,
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    stylesdealerTitle: {
        css: css`
            line-height: 30px;
            color: ${ADIColors.darkBlue1};
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            text-align: center;
            display: block;
            line-height: 1;
            @media only screen and (min-width: 1080px) and (max-width: 1440px) {
                font-size: 12px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                word-break: break-word;
            }
            @media only screen and (min-width: 768px) and (max-width: 1079px) {
                font-size: 16px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                word-break: break-word;
            }
        `,
    },

    cartWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 5px;
            position: relative;
            background: ${ADIColors.white};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                    `,
                    css`
                        display: flex;
                        align-items: flex-start;
                        flex-flow: row;
                    `,
                    css`
                        display: flex;
                        align-items: center;
                        flex-flow: row;
                    `,
                    css`
                        min-height: 506px;
                    `,
                    css`
                        min-height: auto;
                    `,
                ])}
        `,
    },
    brandStyles: {
        nameText: {
            css: css`
                text-decoration: underline;
                font-size: 12px;
                color: ${ADIColors.darkBlack3};
                &:hover {
                    font-weight: bold;
                }
            `,
        },
    },
    cartMobRightSideContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 60%;
                        display: inline-block;
                    `,
                    css`
                        width: 60%;
                        display: inline-block;
                    `,
                    css`
                        width: 60%;
                        display: inline-block;
                    `,
                    null,
                    null,
                ])}
        `,
    },

    cartMobLeftSideContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 40%;
                        display: inline-block;
                    `,
                    css`
                        width: 40%;
                        display: inline-block;
                    `,
                    css`
                        width: 40%;
                        display: inline-block;
                    `,
                    null,
                    null,
                ])}
        `,
    },

    cartMobProdPartNumbers: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        div[class^="GridOffset"] {
                            justify-content: center;
                        }
                    `,
                    css`
                        div[class^="GridOffset"] {
                            justify-content: center;
                        }
                    `,
                    css`
                        div[class^="GridOffset"] {
                            justify-content: center;
                        }
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                ])}
        `,
    },
    newImageWrapper: {
        css: css`
            margin: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            min-height: 240px;
                        `,
                    ],
                    "max",
                );
            }}
            img {
                max-height: 160px;
                max-width: 231px;
                height: 160px;
                width: 160px;
                margin: 0 auto;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            height: auto;
                            width: 100%;
                        `,
                    css`
                            height: auto;
                            width: 100%;
                        `,
                    null,
                    null,
                    null,
                ])}
            }
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
    contentWrapper: {
        css: css`
            padding: 10px 0px 0px 0px;
            > div[class^="GridWrapper"] {
                > div[class^="GridOffset"] {
                    margin: 0 !important;
                    width: 100%;
                }
            }
            @media only screen and (max-width: 767px) {
                padding: 0px 0px 0px 0px;
            }
        `,
    },
    descriptionStyles: {
        productDetailLink: {
            css: css`
                width: 100%;
            `,
            typographyProps: {
                size: 14,
                color: "text.main",
                css: css`
                    word-break: break-word;
                    display: -webkit-box !important;
                    line-clamp: 2 !important;
                    -webkit-line-clamp: 2 !important;
                    -webkit-box-orient: vertical;
                    overflow: hidden !important;
                    color: ${ADIColors.blue5} !important;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: normal;
                `,
            },
        },
    },
    adiProductPriceStyles: {
        price: {
            priceText: {
                weight: "bold",
                css: css`
                    color: ${ADIColors.darkBlue4};
                    display: flex;
                    flex-wrap: wrap;
                    .symbolText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-right: 2px;
                        position: relative;
                        top: 0px;
                    }
                    .priceText {
                        font-size: 30px;
                        font-weight: 900;
                        line-height: 1.1;
                    }
                    .currencyText {
                        font-size: 18px;
                        font-weight: 900;
                        margin-left: 2px;
                        position: relative;
                        top: -2px;
                    }
                    .unitofmeasureText {
                        font-size: 12px !important;
                        position: relative;
                        font-weight: 600;
                        color: #666;
                        display: block !important;
                    }
                `,
            },
        },
    },
    brandGridItem: {
        width: 12,
        css: css`
            padding: 0 20px;
            > a span {
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                    font-weight: 600;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0 15px;
                        `,
                    ],
                    "max",
                );
            }}
            @media screen and (max-width: 767px) {
                > a span {
                    font-size: 10px;
                }
            }
        `,
    },
    cartBrandGridItem: {
        width: 12,
        css: css`
            padding: 0 15px;
            > a span {
                &:hover {
                    text-decoration: underline;
                    font-weight: bold;
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0 15px;
                        `,
                    ],
                    "max",
                );
            }}
            @media screen and (max-width: 767px) {
                > a span {
                    font-size: 10px;
                }
            }
        `,
    },
    cartDescriptionGridItem: {
        width: 12,
        css: css`
            padding-top: 5px;
            padding-bottom: 0;
            a {
                span {
                    color: ${ADIColors.blue6} !important;
                    font-weight: 600 !important;
                    line-height: 1.25;
                    line-clamp: 2 !important;
                    -webkit-line-clamp: 2 !important;
                    -webkit-box-orient: vertical;
                }
                &:hover {
                    span {
                        color: ${getColor("text.link")} !important;
                        font-weight: 600 !important;
                    }
                }
            }
        `,
    },
    cartPartNumberGridItem: {
        width: 12,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            ${TypographyStyle} {
                font-size: 12px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    priceGridItem: {
        width: 12,
        css: css`
            padding: 0px 20px 0px 20px;
            align-items: center;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0px 15px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    cartPriceGridItem: {
        width: 12,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            span {
                font-size: 18px;
                font-weight: 900;
            }
            [data-test-selector="recentlyViewProductPrice"] {
                align-items: center;
                display: flex;
            }
        `,
    },
    deliveryMsgGridItem: {
        width: 12,
        css: css`
            padding: 0px 20px 0px 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0px 15px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    cartAvailabilityGridItem: {
        width: 12,
        css: css`
            padding: 10px 20px 5px 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 10px 15px 5px 15px;
                        `,
                    ],
                    "max",
                );
            }}
            span {
                button {
                    span {
                        font-size: 16px;
                        font-weight: 800;
                        color: ${getColor("text.link")};
                        text-align: left;
                        text-transform: uppercase;
                        position: relative;
                        &:hover {
                            color: ${getColor("text.link")} !important;
                            text-decoration: underline;
                        }
                        &:after {
                            font-family: "good-oatmeal-v2";
                            text-transform: none;
                            line-height: 15px;
                            content: "›";
                            font-size: 30px;
                            position: absolute;
                            top: 1px;
                            right: -24px;
                        }
                    }
                }
            }
        `,
    },
    addToCartGridItem: {
        width: 12,
        css: css`
            padding: 0;
            padding-top: 10px;
            ${FormInputWrapper} {
                margin-top: 0px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 20px;
                    `,
                    css`
                        padding-left: 20px;
                    `,
                    null,
                    null,
                    null,
                ])}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > button {
                            border-top: 0 !important;
                            justify-content: flex-start;
                        }
                    `,
                    css`
                        > button {
                            border-top: 0 !important;
                            justify-content: flex-start;
                        }
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    cartPageAddToCartGridItem: {
        width: 12,
        css: css`
            padding: 0;
            padding-top: 10px;
            padding: 15px;
            > button {
                min-width: 156px;
                max-width: 200px;
                background: ${getColor("text.link")};
                font-weight: 800 !important;
                border: 2px solid ${getColor("text.link")};
                border-radius: 7px;
                > span {
                    color: ${getColor("primary.contrast")} !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > button {
                            border-top: 0 !important;
                            justify-content: flex-start;
                            justify-content: center;
                        }
                    `,
                    css`
                        > button {
                            border-top: 0 !important;
                            justify-content: flex-start;
                            justify-content: center;
                        }
                    `,
                    css`
                        > button {
                            border-top: 0 !important;
                            justify-content: flex-start;
                            justify-content: center;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    addToCartStyles: {
        priceAvailibility: {
            css: css`
                font-weight: bold;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                padding: 0 15px 15px;
                span {
                    font-weight: bold;
                    font-size: ${getProp("theme.typography.headerSecondary.size")};
                }
            `,
        },
        addToCartButton: {
            css: css`
                width: 100%;
                text-align: center;
                padding: 20px 0;
                cursor: pointer;
                transition: 0.2s ease;
                margin-top: auto;
                border-radius: 0;
                background: ${getColor("common.background")};
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                border-top: 1px solid ${getColor("text.disabled")};
                :disabled {
                    background: ${getColor("common.background")} !important;
                    cursor: not-allowed;
                }
                span {
                    color: ${getColor("primary")};
                }
                :hover {
                    background-color: ${getColor("primary")};
                    span {
                        color: ${getColor("primary.contrast")};
                    }
                }

                img {
                    width: 40px;
                }
            `,
        },
    },
    AddToCart: {
        css: css`
            width: auto !important;
            min-width: 170px !important;
            display: inline-block;
            background-color: ${ADIColors.blue5} !important;
            border-radius: 7px !important;
            box-shadow: inset 0 -4px 0 0 #004da6;
            font-size: 16px !important;
            font-weight: 800 !important;
            text-transform: uppercase;
            padding: 6px 10px;
            text-align: center;
            text-decoration: none;
            text-transform: uppercase !important;
            min-height: 40px !important;
            line-height: 16px;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
                border-color: transparent !important;
                opacity: 0.9 !important;
            }
            > span {
                margin-right: 10px;
            }
            > ${StyledWrapper} {
                width: 20%;
                display: flex;
                justify-content: center;
                position: relative;
                align-items: center;
                cursor: pointer;
                transition: all 0.2s ease;
                pointer-events: none;
                img {
                    width: 40px;
                    position: absolute;
                }
            }
        `,
    },
    dealerCertificationWrapper: {
        css: css`
            border-top: solid 1px ${ADIColors.gray7};
            text-align: center;
            padding: 6.5px 4px !important;
            height: 55px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &.productListView {
                border-top: none;
                justify-content: flex-start;
                align-items: flex-start;
                > div:first-child {
                    font-weight: 600;
                }
                > button > span {
                    padding-top: 10px;
                }
            }
        `,
    },
};
